
import React from 'react';
import PropTypes from 'prop-types';
import { Star as StarIcon } from '../../../element/icons';

import ToolsBarItemButton from '../../../components/ToolsBar/ToolsBarItemButton';
import { TOOLS_IDS } from '../../../utils/constants';

const StarButton = ({ selectTool, isSelected = false, t }) => (
  <ToolsBarItemButton
    className="respark_star-tool-button"
    id={TOOLS_IDS.STAR}
    label={t('starTool')}
    Icon={StarIcon}
    onClick={selectTool}
    isSelected={isSelected}
  />
);

StarButton.propTypes = {
  selectTool: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default StarButton;
